var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHover(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#0575E6",
    rx: 5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M14.4852814,9.48528137 L18.4852814,9.48528137 L18.4852814,20.4852814 L14.4852814,20.4852814 L14.4852814,9.48528137 Z M15.4852814,5.48528137 L17.4852814,5.48528137 C18.0375661,5.48528137 18.4852814,5.93299662 18.4852814,6.48528137 L18.4852814,8.48528137 L14.4852814,8.48528137 L14.4852814,6.48528137 C14.4852814,5.93299662 14.9329966,5.48528137 15.4852814,5.48528137 Z M14.4852814,21.4852814 L18.4852814,21.4852814 L18.4852814,22.4852814 L16.4852814,26.4852814 L14.4852814,22.4852814 L14.4852814,21.4852814 Z",
    transform: "rotate(45 16.485 15.985)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHover);
export default __webpack_public_path__ + "static/media/hover.62c32391fed1dc5563f5df254617b0c4.svg";
export { ForwardRef as ReactComponent };